import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  connect() {
    IMask(this.element, {
      mask: "R$ num",
      blocks: {
        num: {
          // Permite ponto como milhar e vírgula como decimal
          mask: Number,
          thousandsSeparator: ".",
          radix: ",",
          scale: 2,
          signed: false,
          normalizeZeros: true,
          padFractionalZeros: true,
          min: 0,
        },
      },
    });
  }
}
